import { AspInvoicesRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspInvoices() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);

  // Called once per Status tab ('open' | 'paid') — callers keep the returned lists.
  async function fetchAspInvoices(params: AspInvoicesRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspInvoices(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchAspInvoices };
}
